import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import isNullOrUndefined from 'scaleflow/utils/isNullOrUndefined';

export default class BackOfANapkinTemplatesNewCustomersV2Component extends Component {
  @service organisation;

  get clv_in_horizon() {
    return this.args.calculation.bon_clv ?? 0;
  }

  get valueBeforeConfidence() {
    return this.calculateValue(
      this.args.calculation.new_customers,
      this.clv_in_horizon,
    );
  }

  calculateValue(new_customers = 0, clv_in_horizon) {
    return (+new_customers || 0) * clv_in_horizon;
  }

  @action
  onConfidenceChange(confidence) {
    const calculation = { ...this.args.calculation };
    calculation.confidence_value = confidence.value;
    calculation.confidence_label = confidence.label;
    this.args.onValueEmit(calculation);
  }

  @action
  handleChange(e) {
    const calculation = { ...this.args.calculation };
    calculation[e.target.name] = Number(e.target.value);
    calculation.value = this.calculateValue(
      calculation.new_customers,
      calculation.bon_clv ?? 0,
    );
    this.args.onValueEmit(calculation);
  }

  @action
  onRender() {
    this.updateValue();
  }

  updateValue() {
    const finalValue = this.finalValue;
    if (isNaN(finalValue)) return;
    const calculation = { ...this.args.calculation };
    calculation.value = this.valueBeforeConfidence;
    this.args.onValueEmit(calculation);
  }

  get confidenceLabel() {
    return this.args.calculation.confidence_label ?? '-';
  }

  get finalValue() {
    if (
      !isNullOrUndefined(this.args.calculation.new_customers) &&
      !isNullOrUndefined(this.clv_in_horizon) &&
      !isNullOrUndefined(this.args.calculation.confidence_value)
    )
      return (
        this.valueBeforeConfidence * +this.args.calculation.confidence_value
      );
    else return '-';
  }

  get isDisabled() {
    return !this.args.editMode;
  }

  @action
  setCustomerValue(e) {
    const calculation = { ...this.args.calculation };
    calculation.bon_clv = e.value;
    calculation.bon_clv_label = e.key;
    this.args.onValueEmit(calculation);
  }
}
